import { z } from 'zod';
import { RequestingEntityTypeSchema } from './enums.schema.js';
export const SubmitRatingRequestSchema = z.object({
    ratingStars: z.number().int().min(1).max(5),
    comment: z.string().max(1000).optional(), // optional, non-PHI
});
export const RatingResponseSchema = z.object({
    id: z.string().uuid(),
    shiftId: z.string().uuid(),
    caregiverId: z.string().uuid(),
    ratedByUserId: z.string().uuid(),
    ratedByEntityType: RequestingEntityTypeSchema,
    ratingStars: z.number().int().min(1).max(5),
    comment: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=rating.schema.js.map